import { SdiDocument } from './SdiDocument';
import { renderPdfWithAttachment } from '../renderPdfWithAttachment';
import type { SDIFormData, SectionToggles } from '../../clinical/types';

export function buildMergedSdiPdf(
    data: SDIFormData,
    attachment: File | null,
    hasOrthopulse: boolean,
    toggles: SectionToggles,
    attachmentBytes?: Uint8Array | null
): Promise<Blob> {
    return renderPdfWithAttachment(
        <SdiDocument data={data} hasOrthopulse={hasOrthopulse} toggles={toggles} />,
        attachment,
        attachmentBytes
    );
}
